module.exports = __webpack_public_path__ + "img/5.1c555a0f.png";